<template>
  <div>
    <div class="row">
      <div
        class="col-md-12 top-button top-buttons-list"
        style="display: inline-flex"
      >
        <div v-if="isPowerUserOrAdministrator">
          <button
            :class="buttonClassObject"
            type="submit"
            class="top-button btn btn-fill btn-wd"
            aria-label="Activer l'edition ou enregistrer"
            @click.prevent="buttonClicked"
          >
            <a v-if="editingDisabled">Editer</a>
            <a v-else>Enregister</a>
          </button>
          <button
            v-show="!editingDisabled"
            type="warning"
            class="top-button btn btn-warning btn-fill btn-wd"
            aria-label="Annuler"
            @click.prevent="cancelButtonClicked"
          >
            Annuler
          </button>
          <button
            v-show="!editingDisabled && !newPersonCreation"
            type="danger"
            class="top-button btn btn-danger btn-fill btn-wd"
            aria-label="Effacer"
            @click.prevent="deleteButtonClicked"
          >
            Effacer
          </button>
        </div>
        <div
          v-show="editingDisabled && !newPersonCreation"
          class="export-dropdown"
        >
          <drop-down>
            <p-button
              slot="title"
              slot-scope="{ isOpen }"
              :aria-expanded="isOpen"
              type="primary"
              round
              block
              class="dropdown-toggle"
            >
              Exporter
            </p-button>
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="exportToCsvIEButtonClicked"
              >Internet Explorer TXT</a
            >
            <a
              class="dropdown-item"
              href="#"
              @click.prevent="exportToCsvOtherButtonClicked"
              >Autres TXT</a
            >
          </drop-down>
        </div>
        <p class="person-error-message">{{ personErrorMessage }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="title">Données de base</h5>
          </div>
          <div class="card-body">
            <form>
              <div class="row">
                <div class="col-md-12">
                  <title-select
                    :disabled="editingDisabled"
                    v-model="user.titleId"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fg-input
                    :disabled="editingDisabled"
                    v-model="user.firstName"
                    type="text"
                    label="Prénom"
                  />
                </div>
                <div class="col-md-6">
                  <fg-input
                    v-validate="'required'"
                    :disabled="editingDisabled"
                    v-model="user.lastName"
                    data-vv-scope="formPersonDetails"
                    name="Nom"
                    type="text"
                    label="Nom"
                  />
                  <span>{{ errors.first('formPersonDetails.Nom') }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <fg-input
                    :disabled="editingDisabled"
                    v-model="user.jobTitle"
                    type="text"
                    label="Titre professionnel"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <fg-input
                    :disabled="editingDisabled"
                    v-model="user.financialRelationship"
                    type="text"
                    label="Relation financière"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="title">Notes</h5>
          </div>
          <div class="card-body">
            <div class="col-md-12">
              <div class="form-group">
                <textarea
                  :disabled="editingDisabled"
                  v-model="user.notes"
                  rows="6"
                  class="form-control border-input notes"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div v-if="!newPersonCreation" class="card">
          <div class="card-header">
            <h5 class="title">Données complémentaires</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <tabs value="Description" tab-content-classes="text-center">
                  <tab-pane key="institutions" title="Institutions">
                    <institutions-person-list
                      :editing-disabled="editingDisabled"
                      :linked-person-id="targetUserId"
                    />
                  </tab-pane>
                  <tab-pane key="communication" title="Communication">
                    <means-of-telecom-cards
                      :means-of-telecom="user.telecomInfos"
                      :editing-disabled="editingDisabled"
                      :type="type"
                      :linked-entity-id="targetUserId"
                      :fetch="fetchUserById"
                    />
                  </tab-pane>
                  <tab-pane key="addresses" title="Adresses">
                    <addresses-cards
                      :addresses="user.addresses"
                      :editing-disabled="editingDisabled"
                      :type="type"
                      :linked-entity-id="targetUserId"
                      :fetch="fetchUserById"
                    />
                  </tab-pane>
                  <tab-pane key="commissions" title="Commissions">
                    <committees-cards :memberships="memberships" />
                  </tab-pane>
                  <tab-pane key="themes" title="Thèmes">
                    <profiles-cards
                      :profiles="user.profiles"
                      :editing-disabled="editingDisabled"
                      :type="type"
                      :linked-entity-id="targetUserId"
                      :fetch="fetchUserById"
                    />
                  </tab-pane>
                </tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  canUserAccessPrivateData,
  isPowerUserOrAdministrator,
} from '@/services/AuthService';
import { Tabs, TabPane } from 'src/components/UIComponents';
import TitleSelect from 'src/components/ApplicationViews/UIComponents/TitleSelect.vue';
import InstitutionsPersonList from 'src/components/ApplicationViews/UIComponents/InstitutionsPersonList.vue';
import MeansOfTelecomCards from 'src/components/ApplicationViews/UIComponents/MeansOfTelecomCards.vue';
import AddressesCards from 'src/components/ApplicationViews/UIComponents/AddressesCards.vue';
import CommitteesCards from 'src/components/ApplicationViews/UIComponents/CommitteesCards.vue';
import ProfilesCards from 'src/components/ApplicationViews/UIComponents/ProfilesCards.vue';

import EventBus from 'src/event-bus';
import swal from 'sweetalert2';
import { Validator } from 'vee-validate';
import fr from 'vee-validate/dist/locale/fr';

export default {
  components: {
    TabPane,
    Tabs,
    TitleSelect,
    InstitutionsPersonList,
    MeansOfTelecomCards,
    AddressesCards,
    CommitteesCards,
    ProfilesCards,
  },
  data() {
    return {
      editingDisabled: true,
      targetUserId: 0,
      newPersonCreation: false,
      currentPage: 0,
      user: {},
      memberships: [],
      errorMessage: '',
      personErrorMessage: '',
      type: 'people',
    };
  },
  computed: {
    canUserAccessPrivateData,
    isPowerUserOrAdministrator,
    buttonClassObject() {
      return {
        'btn-warning': this.editingDisabled,
        'btn-success': !this.editingDisabled,
      };
    },
  },
  watch: {
    $route: {
      handler(newValue) {
        this.newPersonCreation = newValue.params.newPersonCreation;
        if (this.newPersonCreation) {
          this.editingDisabled = false;
        } else {
          this.targetUserId = parseInt(this.$route.params.id, 10);
          this.fetchUserById(this.targetUserId);
        }
      },
      deep: true,
    },
  },
  created() {
    this.newPersonCreation = this.$route.params.newPersonCreation;
    if (this.newPersonCreation) {
      this.editingDisabled = false;
    } else {
      this.targetUserId = parseInt(this.$route.params.id, 10);
      this.fetchUserById(this.targetUserId);
    }
  },
  mounted() {
    // Set the field validator to french
    Validator.localize('fr', fr);
    EventBus.$on('search', this.searchPeople);
  },
  beforeDestroy() {
    EventBus.$off('search', this.searchPeople);
  },
  beforeRouteUpdate(to, from, next) {
    this.targetUserId = parseInt(to.params.id, 10);
    this.fetchUserById(this.targetUserId);
    next();
  },
  methods: {
    searchPeople(searchText) {
      this.$router.push({
        name: 'People',
        params: { searchText },
      });
    },
    buttonClicked() {
      if (this.newPersonCreation) {
        // Validate that the required field are filled before creating record
        this.$validator.validateAll('formPersonDetails').then(result => {
          if (result) {
            this.createRecordPerson();
            this.newPersonCreation = !this.newPersonCreation;
          } else {
            this.personErrorMessage = 'Veuillez corriger les erreurs';
          }
        });
      } else if (!this.editingDisabled) {
        // Validate that the required field are filled before updating record
        this.$validator.validateAll('formPersonDetails').then(result => {
          if (result) {
            this.updateRecordPerson();
            this.editingDisabled = !this.editingDisabled;
          } else {
            this.personErrorMessage = 'Veuillez corriger les erreurs';
          }
        });
      } else {
        this.editingDisabled = !this.editingDisabled;
      }
    },
    deleteButtonClicked() {
      swal({
        title: 'Êtes-vous sûr de vouloir supprimer cette personne?',
        text: "Il ne sera pas possible d'annuler cette suppression!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      }).then(() => {
        this.deleteRecordPerson();
      });
    },
    cancelButtonClicked() {
      if (this.newPersonCreation) {
        this.$router.push({
          name: 'People',
        });
      } else {
        this.editingDisabled = true;
        this.fetchUserById(this.targetUserId);
      }
    },
    doExportTxtRequest() {
      let url = `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/txt/`;

      if (this.canUserAccessPrivateData) {
        url += 'private';
      } else {
        url += 'public';
      }

      url += `/persondetails/${this.targetUserId}/`;

      return this.$http.get(url);
    },
    exportToCsvIEButtonClicked() {
      if (window.navigator.msSaveBlob) {
        this.doExportTxtRequest()
          .then(response => {
            const BOM = '\uFEFF';
            const blobObject = new Blob([BOM + response.data]);

            // Filename
            const headerContent = response.headers['content-disposition'];
            const startFileNameIndex = headerContent.indexOf('"') + 1;
            const endFileNameIndex = headerContent.lastIndexOf('"');
            const filename = headerContent.substring(
              startFileNameIndex,
              endFileNameIndex,
            );

            window.navigator.msSaveBlob(blobObject, `${filename}.txt`);
            // Or msSaveOrOpenBlob
          })
          .catch(error => {
            this.personErrorMessage =
              "Une erreur s'est produite lors de l'exportation, veuillez réessayer ou contacter le support.";
          });
      } else {
        this.personErrorMessage =
          'Cette fonctionnalité est uniquement disponible sur le navigateur Internet Explorer, veuillez exporter "Autres TXT".';
      }
    },
    exportToCsvOtherButtonClicked() {
      this.doExportTxtRequest()
        .then(response => {
          const BOM = '\uFEFF';
          const url = window.URL.createObjectURL(
            new Blob([BOM + response.data]),
          );
          // Filename
          const headerContent = response.headers['content-disposition'];
          const startFileNameIndex = headerContent.indexOf('"') + 1;
          const endFileNameIndex = headerContent.lastIndexOf('"');
          const filename = headerContent.substring(
            startFileNameIndex,
            endFileNameIndex,
          );

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}.txt`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch(error => {
          this.personErrorMessage =
            "Une erreur s'est produite lors de l'exportation, veuillez réessayer ou contacter le support.";
        });
    },
    fetchUserById(id) {
      const dto = this.canUserAccessPrivateData ? 'DTO' : 'PublicDTO';
      return this.$http
        .get(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/personEntities/${id}?projection=person${dto}`,
        )
        .then(response => {
          this.user = response.data;

          this.user.telecomInfos = this.user.telecomInfos.map(moc => ({
            id: `${this.targetUserId}/${moc.meanOfTelecom.mocId}/${moc.type}`,
            ...moc,
          }));

          return this.$http
            .get(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/memberEntities/search/findByMbrPersId?projection=membershipByPerson${dto}&personId=${this.user.id}`,
            )
            .then(resp => {
              this.memberships = resp.data._embedded.memberEntities;
              return this.user;
            });
        });
    },
    createRecordPerson() {
      this.$http
        .post(`${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/people/`, {
          persTitleId: this.user.titleId,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          jobTitle: this.user.jobTitle,
          persAccountno: this.user.financialRelationship,
          notes: this.user.notes,
        })
        .then(response => {
          this.user.id = response.data;
          this.personErrorMessage = '';
          this.newPersonCreation = !this.newPersonCreation;
          this.editingDisabled = !this.editingDisabled;
          this.$router.push({
            name: 'PersonDetails',
            params: { id: this.user.id, newPersonCreation: false },
          });
        })
        .catch(error => {
          this.personErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    updateRecordPerson() {
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/people/${this.user.id}`,
          {
            persTitleId: this.user.titleId,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            jobTitle: this.user.jobTitle,
            persAccountno: this.user.financialRelationship,
            notes: this.user.notes,
          },
        )
        .then(response => {
          this.fetchUserById(this.user.id);
          this.personErrorMessage = '';
        })
        .catch(error => {
          this.personErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    deleteRecordPerson() {
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/people/${this.user.id}`,
        )
        .then(response => {
          this.personErrorMessage = '';
          this.$router.push({
            name: 'People',
          });
        })
        .catch(error => {
          this.personErrorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
  },
};
</script>

<style scoped>
.clickable-element {
  cursor: pointer;
}

textarea.form-control.notes {
  max-height: none;
}

.person-error-message {
  margin-top: 10px;
  margin-left: 200px;
  padding-top: 10px;
  color: darkred;
}

.export-dropdown {
  position: absolute;
  right: 20px;
}

.form-address-street {
  width: 100%;
}

#btn-add {
  position: absolute;
  right: 20px;
  top: 62px;
  margin: 0px;
}

#btn-export {
  position: absolute;
  right: 10px;
  top: 10px;
  margin: 0px;
}

.validation-error {
  color: red;
}

.top-buttons-list {
  min-height: 60px;
}
</style>
